export default __webpack_public_path__ + "static/media/construction-green.5ab60607.svg";